import { createRequestTypes } from '../utils';

export const FETCH_DRAFT_LABELS = createRequestTypes(
  'draftLabelFunction/FETCH_DRAFT_LABELS',
);
export const DELETE_DRAFT_LABEL = createRequestTypes(
  'draftLabelFunction/DELETE_DRAFT_LABEL',
);
export const SAVE_DRAFT_LABEL = createRequestTypes('draftLabelFunction/SAVE_DRAFT_LABEL');
